// src/App.js
import React from "react";
import Home from "./pages/Home";
import "./App.css";
import Contact from "./pages/Contact";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Blog from "./pages/Blog";
import About from "./pages/About";
import Webdevelopment from "./pages/web-development-company-in-noida";
import Contentwriter from "./pages/content-marketing-services";
import Seo from "./pages/seo-agency-noida";
import AIDrivenMarketing from "./pages/ai-automation-services";
import BusinessAutomation from "./pages/business-automation-services";
import Social from "./pages/social-media-marketing-services";
import LeadGeneration from "./pages/LeadGeneration";
import SalesFunnel from "./pages/SalesFunnel";
import WebDesign from "./pages/web-design-services";
import Branding from "./pages/branding-agency-noida";
import CaseStudies from "./pages/CaseStudies";
import Portfolio from "./pages/Portfolio";
import Testimonials from "./pages/Testimonials";
import Resources from "./pages/Resources";
import FreeConsultation from "./pages/FreeConsultation";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import Blog1 from "./pages/low-website-traffic-10-proven-ways-to-increase-organic-traffic-in-30-days";
import Blog2 from "./pages/why-your-website-is-not-ranking-on-google-and-how-to-fix-it-fast-2026-guide";
import Blog3 from "./pages/google-sge-explained-how-search-is-changing-in-2026-and-what-to-do";
import Blog4 from "./pages/what-is-artificial-intelligence-complete-guide-for-beginners-2026";
import Blog5 from "./pages/one-ai-tool-that-can-fully-automate-your-entire-business";
import Blog6 from "./pages/how-ai-can-grow-your-business-faster";
import Blog7 from "./pages/why-marketers-fail-lead-generation-2026";
import Blog8 from "./pages/linkedin-b2b-lead-generation-strategies-2026";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/web-development-company-in-noida"
            element={<Webdevelopment />}
          />
          <Route path="/seo-agency-noida" element={<Seo />} />
          <Route
            path="/content-marketing-services"
            element={<Contentwriter />}
          />
          <Route
            path="/ai-automation-services"
            element={<AIDrivenMarketing />}
          />
          <Route
            path="/business-automation-services"
            element={<BusinessAutomation />}
          />
          <Route
            path="/lead-generation-services"
            element={<LeadGeneration />}
          />
          <Route path="/sales-funnel-optimization" element={<SalesFunnel />} />
          <Route path="/social-media-marketing-services" element={<Social />} />

          <Route path="/web-design-services" element={<WebDesign />} />
          <Route path="/branding-agency-noida" element={<Branding />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/Testimonials" element={<Testimonials />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/free-consultation" element={<FreeConsultation />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/Terms" element={<Terms />} />
       
          <Route path="*" element={<NotFound />} />

          {/* blogs */}
          <Route
            path="/low-website-traffic-10-proven-ways-to-increase-organic-traffic-in-30-days"
            element={<Blog1 />}
          />
          <Route
            path="/why-your-website-is-not-ranking-on-google-and-how-to-fix-it-fast-2026-guide"
            element={<Blog2 />}
          />
          <Route
            path="/google-sge-explained-how-search-is-changing-in-2026-and-what-to-do"
            element={<Blog3 />}
          />
          <Route
            path="/what-is-artificial-intelligence-complete-guide-for-beginners-2026"
            element={<Blog4 />}
          />
          <Route
            path="/one-ai-tool-that-can-fully-automate-your-entire-business"
            element={<Blog5 />}
          />
            <Route
            path="/how-ai-can-grow-your-business-faster"
            element={<Blog6 />}
          />
            <Route
            path="/why-marketers-fail-lead-generation-2026"
            element={<Blog7 />}
          />
            <Route
            path="/linkedin-b2b-lead-generation-strategies-2026"
            element={<Blog8 />}
          />
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;
